import { useEffect, useState, useRef } from 'react'
import './style.css'
import Grafic from './Grafic'
import {
	calculCentil,
	calculCentilComunitat,
	comunitatById,
	comunitats,
	edats,
	formatEnter,
	interpolate,
	// souMax,
} from './utils'
// import MesInfo from './Grafic/MesInfo'
import Barra from './Barra'
import HeaderEmbed from '@common/HeaderEmbed'
import percentils from './assets/dades/percentils.json'
import diccionari from './assets/textos.json'

export function App({ lang, preview }) {
	// Textos
	const textos = diccionari[lang]
	// Constants
	const souMin = 14000
	const souMax = 720000
	// Refs
	const refForm = useRef(null)
	const refGrafic = useRef(null)
	// Estats
	const initialState = {
		sou: null,
		// percentUsuari: 50,
		comunitat: null,
		// edat: null,
	}
	const [dades, setDades] = useState(null)
	const [formData, setFormData] = useState(initialState)
	const [errors, setErrors] = useState(initialState)
	const [selectOpen, setSelectOpen] = useState(false)
	const [editSou, setEditSou] = useState(false)

	// Effects
	useEffect(() => {
		dades && refGrafic.current.scrollIntoView({ behavior: 'smooth' })
	}, [dades])
	useEffect(() => {
		document.getElementById('app-calculadora-sou').style.setProperty('--percent-usuari', formData.percentUsuari + '%')
	}, [formData.percentUsuari])

	// Funcions
	const handleSubmit = (e) => {
		e.preventDefault()
		let hihaError = false
		const { sou, comunitat /*, edat*/ } = formData
		if (sou > souMax || sou < souMin) {
			setErrors({ ...errors, sou: true })
			refForm.current.scrollIntoView({ behavior: 'smooth' })
			hihaError = true
		}
		if (!sou || !comunitat /*|| !edat*/) {
			setErrors({
				sou: hihaError || !sou,
				comunitat: !comunitat /*, edat: !edat */,
			})
			refForm.current.scrollIntoView({ behavior: 'smooth' })
			hihaError = true
		}
		if (!hihaError) {
			setDades(formData)
		}
	}
	const reset = () => {
		setDades(null)
		setFormData(initialState)
		setErrors(initialState)
		setTimeout(() => {
			refForm.current.scrollIntoView({ behavior: 'smooth' })
		}, 300)
	}
	const toggleSelect = (id) => {
		setSelectOpen(id === selectOpen ? false : id)
	}

	return (
		<>
			{preview && <HeaderEmbed />}
			<form onSubmit={handleSubmit} ref={refForm} autoComplete='off'>
				<header className='mb-D'>
					<h3 className='e3'> {textos.titol}</h3>
					<p className='e8 text-gris-fosc'>{textos.subtitol}</p>
				</header>
				{/* Sou */}
				<div className={`input-group mb-D ${errors.sou ? 'input-error' : ''}`}>
					<label className='e4'>{textos.pregunta1}</label>
					<p className='e8 mb-20 text-gris-fosc'>{textos.text_pregunta1}</p>
					<div className='input'>
						<input
							type={editSou ? 'number' : 'text'}
							name='sou'
							min={0}
							value={formData.sou ? (editSou ? formData.sou : formatEnter(formData.sou) + '€') : ''}
							onKeyPress={(e) => {
								// Bloqueig tecles , . - e, i deixar només números
								if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
									e.preventDefault()
								}
							}}
							onChange={(e) => {
								setFormData({
									...formData,
									sou: e.target.value === '0' || e.target.value === '' ? null : parseInt(e.target.value),
								})
								errors.sou && e.target.value !== '0' && e.target.value !== '' && setErrors({ ...errors, sou: null })
							}}
							placeholder='0€'
							onFocus={() => setEditSou(true)}
							onBlur={() => setEditSou(false)}
						/>
					</div>
					{errors.sou && <p className='t13 error-feedback'>{textos.error_pregunta1}</p>}
				</div>
				{/* Comunitat autònoma */}
				<div className='input-group mb-D'>
					<label className='e4'>{textos.pregunta2}</label>
					<p className='e8 mb-20'>{textos.text_pregunta2}</p>
					<div
						className={`custom-select ${selectOpen === 'comunitat' ? 'active' : ''} ${
							errors.comunitat ? 'input-error' : ''
						}`}
					>
						<div className='select-header' onClick={() => toggleSelect('comunitat')}>
							{comunitats.find((comunitat) => formData.comunitat === comunitat.id)?.nom[lang] || textos.comunitat}
						</div>
						<div className='options'>
							{comunitats.map((comunitat) => (
								<div
									key={comunitat.id}
									onClick={() => {
										setFormData({ ...formData, comunitat: comunitat.id })
										errors.comunitat && setErrors({ ...errors, comunitat: null })
										setSelectOpen(false)
									}}
								>
									{comunitat.nom[lang]}
								</div>
							))}
						</div>
					</div>
					{errors.comunitat && <p className='t13 error-feedback'>{textos.error_pregunta2}</p>}
				</div>
				{/* Edat */}
				{/* <div className={`input-group mb-D ${errors.edat ? 'input-error' : ''}`}>
					<label className='e4'>3. Quina edat tens?</label>
					<p className='e8 mb-20 text-gris-fosc'>Aclariments</p>
					<div
						className={`custom-select ${selectOpen === 'edat' ? 'active' : ''}`}
					>
						<div className='select-header' onClick={() => toggleSelect('edat')}>
							{edats.find((edat) => formData.edat === edat.id)?.text || 'Edat'}
						</div>

						<div className='options'>
							{edats.map((edat) => (
								<div
									key={edat.id}
									onClick={() => {
										setFormData({ ...formData, edat: edat.id })
										errors.edat && setErrors({ ...errors, edat: null })
										setSelectOpen(false)
									}}
								>
									{edat.text}
								</div>
							))}
						</div>
					</div>
				</div> */}
				{/* Percentatge */}
				{/* <div className='input-group mb-B'>
					<label className='e4'>
						4. Quanta gent creus que cobra menys que tu?
					</label>
					<p className='e8 mb-20 text-gris-fosc'>
						Escriu o deslplaça la boleta en funció de la teva percepció
					</p>
					<div className='input-range'>
						<input
							type='range'
							name='percentUsuari'
							value={formData.percentUsuari}
							onChange={(e) =>
								setFormData({
									...formData,
									percentUsuari: parseInt(e.target.value),
								})
							}
						/>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='24'
							height='24'
							viewBox='0 0 24 24'
							fill='none'
							className={formData.percentUsuari !== 50 ? '' : 'visible'}
						>
							<g clipPath='url(#clip0_2290_2179)'>
								<path
									d='M20.5 2V4.02C18.18 2.13 15.22 1 12 1C8.78 1 5.82 2.13 3.5 4.02V2H2V5.5V7H3.5H7V5.5H4.09C6.2 3.64 8.97 2.5 12 2.5C15.03 2.5 17.79 3.64 19.91 5.5H17V7H20.5H22V5.5V2H20.5Z'
									fill='#555555'
								/>
								<path
									d='M18.89 13.7699L15.09 12.0999C14.96 12.0399 14.81 11.9999 14.65 11.9999H14V7.62988C14 6.30988 13.04 5.12988 11.73 5.00988C10.25 4.87988 9 6.04988 9 7.49988V15.6499L7.13 15.2499C6.94 15.2199 6.11 15.0999 5.4 15.8099L4 17.2199L9.12 22.4099C9.49 22.7899 10 22.9999 10.53 22.9999H17.08C18.06 22.9999 18.89 22.2999 19.05 21.3299L19.97 15.8899C20.12 15.0299 19.68 14.1699 18.89 13.7699ZM18 15.5599L17.08 20.9999H10.53L6.83 17.2199L11 18.1099V7.49988C11 7.21988 11.22 6.99988 11.5 6.99988C11.78 6.99988 12 7.21988 12 7.49988V13.6799H13.76L18 15.5599Z'
									fill='#555555'
								/>
							</g>
							<defs>
								<clipPath id='clip0_2290_2179'>
									<rect width='24' height='24' fill='white' />
								</clipPath>
							</defs>
						</svg>
						<div className='t11 input-text'>{formData.percentUsuari}%</div>
					</div>
				</div> */}

				<button type='submit' className='ara-button'>
					<span className='button-content'>{textos.boto_submit}</span>
				</button>

				<section ref={refGrafic}>
					{dades && (
						<>
							<h3 className='e3 mt-C mb-B'>{textos.titol_resultat}</h3>
							<p className='e5 mb-A'>
								<span className='e4'>
									{interpolate(textos.titolet1, {
										lloc: comunitatById(dades.comunitat, lang),
									})}
								</span>
								<br />
								<span
									dangerouslySetInnerHTML={{
										__html: interpolate(textos.text_percents, {
											percent1: calculCentilComunitat(dades.sou, dades.comunitat),
											percent2: 100 - calculCentilComunitat(dades.sou, dades.comunitat),
										}),
									}}
								/>
							</p>
							<Barra
								className='mb-B'
								percentatge={Math.round(calculCentilComunitat(dades.sou, dades.comunitat))}
								textos={textos}
							/>
							<p
								className='e5 mb-B'
								dangerouslySetInnerHTML={{
									__html: interpolate(textos.text_explicatiu, {
										sou: formatEnter(dades.sou),
									}),
								}}
							></p>
							<p className='e5 mb-A'>
								<span className='e4'>{textos.titolet2}</span>
								<br />
								<span
									dangerouslySetInnerHTML={{
										__html: interpolate(textos.text_percents, {
											percent1: calculCentil(dades.sou),
											percent2: 100 - calculCentil(dades.sou),
										}),
									}}
								/>
							</p>
							<Barra className='mb-A' percentatge={calculCentil(dades.sou)} textos={textos} />

							<Grafic
								dadesForm={dades}
								percentils={percentils.filter((percentil) => percentil.comunitat === 'total')}
								tipus='total'
								textos={textos}
							/>
							<p className='e5 mt-B'>{textos.text_final}</p>
							{/* <Grafic
								dadesForm={dades}
								percentils={percentils.filter(
									(percentil) => percentil.comunitat === dades.comunitat
								)}
								tipus='comunitat'
							/> */}
							{/* <div className='mes-dades'>
								<h4 className='e3 mb-A'>i a més a més...</h4>
								<MesInfo dadesForm={dades} filtre={filtreComunitat} />
							</div> */}
						</>
					)}
				</section>
				{dades && (
					<footer className='peu-calculadora mt-B'>
						<button type='reset' onClick={reset} className='ara-button'>
							<span className='button-content up'>{textos.boto_reset}</span>
						</button>
					</footer>
				)}
			</form>
		</>
	)
}
